import { ComponentProps, FC } from 'react';
import { Skeleton } from 'antd';

type AvatarSkeletonProps = ComponentProps<typeof Skeleton.Avatar>;

const AvatarSkeleton: FC<AvatarSkeletonProps> = ({ active = true, shape = 'circle', ...props }) => (
    <Skeleton.Avatar active={active} shape={shape} {...props} />
);

export default AvatarSkeleton;
